<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-10-30 13:01:46
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2019-10-30 13:19:02
 * @Description: file content
 -->
<template>
  <div class="reg-hr-agreement">
    <div class="content">
      <div class="myh1">用户注册协议</div>
      <div class="myh2">一、注册须知及流程</div>
      <p>
        1、关注武地置业通进入“全民营销”；
        2、根据系统引导，选择注册身份，推荐人必须提供本人真实、正确、最新及完整的资料。
      </p>
      <div class="myh2">二、特别声明</div>
      <div>请您仔细阅读如下条款，并遵照执行；</div>
      <p>1、当您注册为本平台的推荐人时，即意味着您接受本平台的所有规则条款。当本平台的规则和条款变更时，变更后的规则和条款对您有约束力，武汉地产集团对此不再另行通知。</p>
      <p>2、您的注册、登录行为即视为接受本平台的的所有条款、规则(包括其今后更新、修改的条款）。请您妥善掌管注册的账号、密码等信息，勿向他人泄露。凡是以您注册的账号成功登录以及登录后的操作行为均视为您亲自操作，并由您承担全部责任，本平台不承担涉及注册账号系他人未经您授权或许可[无论是否属实]进行登录并进行后续操作而给您本人或其他第三方造成的任何损失赔偿或侵权等责任。</p>
      <p>3、您登录平台登记被推荐人信息的行为，即视为您已取得被推荐人的同意或授权您可按本系统设定的填写内容及规则规定录入被推荐人的相关信息，且该类信息的真实性等相关法律责任均由您和被推荐人承担，就您录入的被推荐人的一切信息，武汉地产集团及其各项目公司可根据项目营销的需要进行使用，包括但不限于对被推荐人进行电话问访、信息进行核实等，武汉地产集团及其各项目开发公司的前述行为均不视为侵权，如发生被推荐人对武汉地产集团及其各项目开发公司的前述行为投诉、索赔所产生的一切纠纷及责任，武汉地产集团及其各项目开发公司均有权要求您负责处理解决并承担责任，且如该类事件发生，武汉地产集团有权暂停直至终止您对本平台的使用，包括但不限于账号阶段性封停使用（暂无法登录）、部分操作权利限制或取消、账号注销等，凡因武汉地产集团行使前述权利给您造成的任何损失或不便均由您自行承担。</p>
      <p>4、每一项目的开发公司对您的推介行为设定的相关权利、义务可能会有所不同，请您务必详细阅读开发公司公示的相关内容，您通过本平台进行的推介行为也视为您完全接受各项目开发公司的公示设定内容。</p>
      <p>5、您登录本网站进行任何行为均应符合各项法律规定，如果您的注册账号在本网站进行违法、违规行为，或遭受武汉地产集团下属公司客户投诉、遭受其他第三人举报，武汉地产集团除有权追究您的行为造成的损失外，还有权暂停直至终止您对账号的使用，包括但不限于账号阶段性封停使用（暂无法登录）、部分操作权利限制或取消、账号注销等，凡因武汉地产集团行使前述权利给您造成的任何损失或不便均由您自行承担。</p>
      <p>6、推荐人的姓名、手机号码、银行卡账号以及银行开户行为作为佣金结算对象的凭证，若因推荐人的资料错误、不实，导致不能成功结算佣金的后果由推荐人自行承担。</p>
      <p>7、您推荐的客户在推荐保护期内成功购买对应的项目房源，您将会获得推荐佣金。项目开发公司会对您的推荐进行核实，核实后会进行佣金发放，不同项目佣金规则不尽相同，关于各项目的佣金结算具体规定，烦请您自行向各项目开发公司进行咨询了解。</p>
      <p>8、对您的注册个人信息，武汉地产集团将依法严格保密并遵守国家对个人信息管理的规定，除按法律法规的法定程序必须向国家权力机关或其他第三方依法提供或披露外，武汉地产集团不会在非经您事前许可下对外披露及提供。</p>
      <p>9、武汉地产集团对本协议条款拥有最终解释权。</p>
    </div>
    <div class="btns">
      <div class="up" @click="clickBack">返回</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    clickBack() {
      this.$emit("close");
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="css" scoped>
.reg-hr-agreement {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
  overflow: scroll;
}
.content {
  width: 90%;
  margin: 0 auto;
  line-height: 30px;
  padding-bottom: 130px;
}
.myh1 {
  font-size: 18px;
  text-align: center;
  line-height: 50px;
}
.myh2 {
  font-size: 16px;
  line-height: 50px;
}
.btns {
  position: fixed;
  bottom: 50px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.btns > div {
  width: 50%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  border: none;
  border-radius: 15px;
}

.btns .up {
  border: 1px solid #f2494d;
  color: #f68d8f;
}
</style>